import React, { PropsWithChildren } from 'react'

import { ReactFC } from 'common/types/ReactFC'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'

type TrustedPartnerCardType = {}

const TrustedPartnerCard: ReactFC<
  PropsWithChildren<TrustedPartnerCardType>
> = ({}) => {
  const size = useWindowSize()

  return (
    <div className='card card_bg-gradient-purple-pink partners-card overflow-hidden'>
      <div className='px-5 pe-lg-0 ps-lg-20 position-relative'>
        <div className='d-flex gap-0 align-items-center justify-content-between'>
          <h1
            className='fs-fluid-40-80 lh-105 lh-lg-118 fw-semibold color-white d-block mb-lg-17 mt-lg-26 mt-17 mb-28'
            style={{
              minWidth: size.isLgOrHigher ? 500 : undefined,
            }}
          >
            Trusted by <br /> Global Leaders
          </h1>

          <div />

          {size.isLgOrHigher && (
            <div className='d-flex align-items-end justify-content-end'>
              <img
                {...generateSrcSet(
                  '/images/new/robot-arm-pointing-left-angle.png',
                  880,
                  303,
                )}
                alt='Robot arm pointing left'
                className='w-100 object-fit-contain'
                height={303}
                width={880}
              />
            </div>
          )}
        </div>

        {!size.isLgOrHigher && (
          <img
            {...generateSrcSet('/images/new/arm-pointing-down.png', 128, 251)}
            loading='lazy'
            alt='Robot arm pointing down'
            className='position-absolute top-0 right-0'
          />
        )}
      </div>
      <div className='partners-marquee-container pb-10 pb-lg-9'>
        <div className='partners-marquee'>
          <img
            {...generateSrcSet('/images/logos/partners/partners.svg', 816, 72)}
            className='pe-54'
            alt='partners'
            loading='lazy'
          />
          <img
            {...generateSrcSet('/images/logos/partners/partners.svg', 816, 72)}
            className='pe-54'
            alt='partners'
            loading='lazy'
          />
        </div>
      </div>
    </div>
  )
}

export default TrustedPartnerCard
